import { kAnalyticsFeatureDraftPage } from '@/analytics/constants'
import { DocxDownloadSurface, DocxFolderSource } from '@/analytics/enums/docx-export.enums'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent, type AnalyticsEventProperties } from '@/analytics/schema/events.schema'

type DocxExportAnalyticsEvent = AnalyticsEvent.DocxExportDownloaded | AnalyticsEvent.DocxExportsFolderOpened

function trackDocxExportEvent<T extends DocxExportAnalyticsEvent>(track: TrackEventFn, event: T, props: AnalyticsEventProperties[T]) {
  track(event, { ...props, feature: kAnalyticsFeatureDraftPage } as AnalyticsEventProperties[T], { suppressFeatureInheritance: true })
}

export function trackDocxExportDownloaded(track: TrackEventFn, input: { userFileId: string; docxDownloadSurface: DocxDownloadSurface; exportId: string }) {
  trackDocxExportEvent(track, AnalyticsEvent.DocxExportDownloaded, input)
}

export function trackDocxExportsFolderOpened(
  track: TrackEventFn,
  input: { docxFolderSource: DocxFolderSource; exportId?: string; userFileId?: string; conversationId?: string }
) {
  trackDocxExportEvent(track, AnalyticsEvent.DocxExportsFolderOpened, {
    docxFolderSource: input.docxFolderSource,
    ...(input.exportId ? { exportId: input.exportId } : {}),
    ...(input.userFileId ? { userFileId: input.userFileId } : {}),
    ...(input.conversationId ? { conversationId: input.conversationId } : {}),
  })
}
